import { render, staticRenderFns } from "./Hierarchy-add-or-update.vue?vue&type=template&id=620cb70f&scoped=true"
import script from "./Hierarchy-add-or-update.vue?vue&type=script&lang=js"
export * from "./Hierarchy-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./Hierarchy-add-or-update.vue?vue&type=style&index=0&id=620cb70f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620cb70f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620cb70f')) {
      api.createRecord('620cb70f', component.options)
    } else {
      api.reload('620cb70f', component.options)
    }
    module.hot.accept("./Hierarchy-add-or-update.vue?vue&type=template&id=620cb70f&scoped=true", function () {
      api.rerender('620cb70f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/children/Hierarchy-add-or-update.vue"
export default component.exports